import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Toggletip as Toggletip$1 } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const Toggletip = (props)=>{
    const { getLabel  } = useIntl();
    var ref;
    const ariaLabel = (ref = props['aria-label']) !== null && ref !== void 0 ? ref : getLabel('common.tooltip');
    return /*#__PURE__*/ React.createElement(Toggletip$1, swcHelpers.extends({}, props, {
        ariaLabel: ariaLabel,
        "data-t": "tooltip"
    }));
};

export { Toggletip };
//# sourceMappingURL=Toggletip.js.map
